<a class="nav-link dropdown-toggle white btn-hover-pepsico fnt-13" role="button"
    id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <img src="./assets/images/pepsico-icons-menu3.png" width="25">
    <span *ngIf="showAlert()" class="icon-button__badge"></span>
</a>
<div class="hover-label">Notificaciones</div>
<div class="dropdown-menu notificationBox" aria-labelledby="dropdownMenuLink">
    <div  class="notificationTriangle-notificaciones-desktop is-active"></div>
        <div class="notificationHeader">            
            <div class="notificationHeader--title">
                Avisos Importantes
            </div>
            <div class="notificationHeader--unread">
                <div>{{alertsCount()}} Nuevos </div>
            </div>
        </div>
    <div>
    <div class="notificationList">
        <div>
        @for (item of notificationDataService.notifications(); track $index) {
            <div class="notification" (click)="read(item)">
                <a tabindex="0">
                <div class="notification--subHeader">
                    <div class="notification--subHeader--title">
                    {{item.title}}
                    </div>
                    <div class="notification--subHeader--hour">
                        <span>{{ item.creationDate | date:'MMM dd':'' }}</span>                                        
                    </div>
                </div>
                <div class="notification--description">
                {{item.message}}
                </div>
                </a>
            </div>
        }
        </div>
    </div>
    </div>
</div>